"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    root: {
      '& $button': {
        '&:first-child': {
          borderRight: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        },
        '&:last-child': {
          borderLeft: 0,
          borderRadiusRight: 0,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0
        }
      }
    },
    active: {
      boxShadow: 'inset 0 0 8px 0 rgba(120,133,144,.4)',
      background: theme.colors.tableHeader
    },
    button: {}
  };
};

exports.default = _default;